<div class="sidebar-proyect" [ngClass]="{ close: !isHoveredSide }">
    <!--   -->
    <div class="logo-details">
        <i class="bx bxl-c-plus-plus"></i>
        <span class="logo_name"></span>
    </div>
    <ul class="nav-links">
        <li (click)="setActive(0)" [ngClass]="{ active: activeIndex === 0 }">
            <a routerLink="/app/pages/proyectos">
                <img src="../../../../assets/img/imgMenu/proyectos.png" width="35px" height="35px" class="menu-icon" />
                <span class="link_name">Config. proyectos </span>
            </a>
        </li>
        <li id="tour-marketing-menu">
            <div class="iocn-link" id="tour-marketing-submenu" (click)="setActive(1)" [ngClass]="{ active: activeIndex === 1 }">
                <a>
                    <img src="../../../../assets/img/imgMenu/Marketing.png" width="35px" height="35px" class="menu-icon" />
                    <span class="link_name">Marketing</span>
                </a>
                <i class="bx bxs-chevron-down arrow-proyect arrow-proyect-marketing"></i>
            </div>
            <ul id="tour-marketing-submenu-menu" class="sub-menu">
                <li id="tour-Campana-submenu" (click)="setActiveSubmenu(1, 1)" [ngClass]="{ active: activeSubmenuIndex === 1 }">
                    <a class="c-pointer" routerLink="/app/pages/campanas-business"><i class="bx bxs-megaphone"></i> Campañas</a
          >
        </li>
        <li
          id="tour-WhatsApp-submenu"
          (click)="setActiveSubmenu(2, 1)"
          [ngClass]="{ active: activeSubmenuIndex === 2 }"
        >
          <a class="c-pointer" routerLink="/app/pages/whatsapp-conexion"
            ><i class="bx bxl-whatsapp"></i> WhatsApp</a
          >
        </li>
        <li
          id="tour-remarketing-submenu"
          (click)="setActiveSubmenu(3, 1)"
          [ngClass]="{ active: activeSubmenuIndex === 3 }"
        >
          <a class="c-pointer" routerLink="/app/pages/modulo-marketing"
            ><i class="bx bxs-share"></i> Remarketing</a
          >
        </li>
        <li
          id="tour-medios-contacto-submenu"
          (click)="setActiveSubmenu(4, 1)"
          [ngClass]="{ active: activeSubmenuIndex === 4 }"
        >
          <a class="c-pointer" routerLink="/app/pages/viaProspeccion"
            ><i class="bx bx-filter-alt"></i> Medios de contacto</a
          >
        </li>
        <li
          id="tour-motivos-cancelacion-submenu"
          (click)="setActiveSubmenu(5, 1)"
          [ngClass]="{ active: activeSubmenuIndex === 5 }"
        >
          <a class="c-pointer" routerLink="/app/pages/motivos-cancelacion"
            ><i class="fa-solid fa-xmark"></i> Motivos de descarte</a
          >
        </li>
        <li
          id="tour-bodyperson-submenu"
          (click)="setActiveSubmenu(6, 1)"
          [ngClass]="{ active: activeSubmenuIndex === 6 }"
        >
          <a class="c-pointer" routerLink="/app/pages/bodyPerson-personalizado"
            ><i class="bx bx-user"></i> Body Person</a
          >
        </li>
      </ul>
    </li>
    <li id="tour-tiendas-menu">
      <div
        class="iocn-link"
        (click)="setActive(7)"
        [ngClass]="{ active: activeIndex === 7 }"
      >
        <a>
          <img
            src="../../../../assets/img/imgMenu/Tienda.png"
            width="35px"
            height="35px"
            class="menu-icon"
          />
          <span class="link_name">E-commerce</span>
        </a>
                    <i class="bx bxs-chevron-down arrow-proyect"></i>
</div>
<ul class="sub-menu">
    <li (click)="setActiveSubmenu(1, 7)" [ngClass]="{ active: activeSubmenuIndex === 1 }">
        <a class="c-pointer" routerLink="/app/pages/tiendas-list"><i class="fa-solid fa-shop"></i> Mis e-commerce</a
          >
        </li>
      </ul>
    </li>

    <li id="tour-finanzas-menu">
      <div
        class="iocn-link"
        (click)="setActive(2)"
        [ngClass]="{ active: activeIndex === 2 }"
      >
        <a>
          <img
            src="../../../../assets/img/imgMenu/Ventas.png"
            width="35px"
            height="35px"
            class="menu-icon"
          />
          <span class="link_name">Finanzas</span>
        </a>
        <i class="bx bxs-chevron-down arrow-proyect"></i>
        </div>
        <ul *ngIf="usuarioInfo?.tipoNegocio == 3" class="sub-menu">
            <li (click)="setActiveSubmenu(6, 2)" [ngClass]="{ active: activeSubmenuIndex === 6 }">
                <a routerLink="/app/pages/venta/ventas" class="c-pointer"><i class="bx bx-wallet-alt"></i> Ventas</a
          >
        </li>

        <li
          (click)="setActiveSubmenu(8, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 8 }"
        >
          <a routerLink="/app/pages/ventas-business" class="c-pointer"
            ><i class="bx bx-wallet-alt"></i> Ventas business</a
          >
        </li>
        <li
          (click)="setActiveSubmenu(7, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 7 }"
        >
          <a routerLink="/app/pages/billetera" class="c-pointer"
            ><i class="bx bxs-bank"></i> Pago comisiones</a
          >
        </li>
      </ul>
      <ul *ngIf="usuarioInfo?.tipoNegocio == 2" class="sub-menu">
        <li
          (click)="setActiveSubmenu(8, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 8 }"
        >
          <a routerLink="/app/pages/ventas-business" class="c-pointer"
            ><i class="bx bx-wallet-alt"></i> Ventas business</a
          >
        </li>
      </ul>
      <ul *ngIf="usuarioInfo?.tipoNegocio == 1" class="sub-menu">
        <li
          (click)="setActiveSubmenu(9, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 9 }"
        >
          <a routerLink="/app/pages/linea-tiempo-lote" class="c-pointer"
            ><i class="bx bx-history"></i> Seguimiento de unidad</a
          >
        </li>
        <li
          (click)="setActiveSubmenu(6, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 6 }"
        >
          <a routerLink="/app/pages/venta/ventas" class="c-pointer"
            ><i class="bx bx-wallet-alt"></i> Ventas</a
          >
        </li>
        <li
          (click)="setActiveSubmenu(7, 2)"
          [ngClass]="{ active: activeSubmenuIndex === 7 }"
        >
          <a routerLink="/app/pages/billetera" class="c-pointer"
            ><i class="bx bxs-bank"></i> Pago comisiones</a
          >
        </li>
      </ul>
    </li>

    <li>
      <div
        class="iocn-link"
        (click)="setActive(10)"
        [ngClass]="{ active: activeIndex === 10 }"
      >
        <a>
          <img
            src="../../../../assets/img/imgMenu/postventa.png"
            width="35px"
            height="35px"
            class="menu-icon"
          />
          <span class="link_name">Post venta</span>
        </a>
                <i class="bx bxs-chevron-down arrow-proyect"></i>
                </div>

                <ul *ngIf="usuarioInfo?.tipoNegocio == 3" class="sub-menu">
                    <li (click)="setActiveSubmenu(9, 2)" [ngClass]="{ active: activeSubmenuIndex === 9 }">
                        <a routerLink="/app/pages/linea-tiempo-lote" class="c-pointer"><i class="bx bx-trip"></i> Seguimiento de unidad</a
          >
        </li>
      </ul>
    </li>

    <li
      id="tour-crm-menu"
      (click)="regresarPortal()"
      [ngClass]="{ active: activeIndex === 3 }"
    >
      <a>
        <img
          src="../../../../assets/img/imgMenu/billetera.png"
          width="35px"
          height="35px"
          class="menu-icon"
        />
        <span class="link_name">Ir al CRM</span>
      </a>
                    </li>
                    <!-- *ngIf="(this.usuarioLogeado.tipo == 'DV' && this.usuarioLogeado.tipoRegistro=='BK')" -->
                    <li *ngIf="
        this.usuarioLogeado.tipo == 'DV' &&
        this.usuarioLogeado.tipoRegistro == 'BK'
      " id="tour-ganancias-menu" (click)="setActive(6)" [ngClass]="{ active: activeIndex === 6 }">
                        <a routerLink="/app/pages/gananciasREDA">
                            <img src="../../../../assets/img/imgMenu/Billete.png" width="35px" height="35px" class="menu-icon" />
                            <span class="link_name">Ganancias</span>
                        </a>
                    </li>
                    <li id="tour-incentivos-menu" (click)="setActive(4)" [ngClass]="{'active': activeIndex === 4}">
                        <a routerLink="/app/pages/incentivos">
                            <img src="../../../../assets/img/imgMenu/Rewards.png" width="35px" height="35px" class="menu-icon">
                            <span class="link_name">Incentivos</span>
                        </a>
                    </li>
                    <li id="tour-gestion-usuarios-menu" (click)="setActive(5)" [ngClass]="{ active: activeIndex === 5 }">
                        <div class="iocn-link">
                            <a routerLink="/app/pages/gestion-usuarios">
                                <img src="../../../../assets/img/imgMenu/GestionUsuariosMenu.png" width="35px" height="35px" class="menu-icon" />
                                <span class="link_name">Gestión de usuarios</span>
                            </a>
                        </div>
                    </li>
                    <li>
                        <div class="profile-details" (click)="regresarPortal()">
                            <div class="profile-content c-pointer">
                                <i class="bx bx-log-out"></i>
                                <span class="profile_name font-weight-bold">Ir al CRM</span>
                            </div>
                        </div>
                    </li>
                </ul>
                </div>